import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'
import type { ScanStatus } from '@/lib/types'

interface StatusBadgeProps {
  status: ScanStatus
  className?: string
}

const statusConfig = {
  draft: {
    labelKey: 'scan.status.concept',
    className: 'bg-orange-100 text-orange-800 border-orange-300',
  },
  processing: {
    labelKey: 'scan.status.verwerken',
    className: 'bg-blue-100 text-blue-800 border-blue-300',
  },
  ready: {
    labelKey: 'scan.status.klaar',
    className: 'bg-green-100 text-green-800 border-green-300',
  },
  confirmed: {
    labelKey: 'scan.status.confirmed',
    className: 'bg-green-100 text-green-800 border-green-300',
  },
  failed: {
    labelKey: 'scan.status.mislukt',
    className: 'bg-red-100 text-red-800 border-red-300',
  },
  queued: {
    labelKey: 'scan.status.inWachtrij',
    className: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  },
  no_messages: {
    labelKey: 'scan.status.geenBerichtenGevonden',
    className: 'bg-purple-100 text-purple-800 border-purple-300',
  },
  deleted: {
    labelKey: 'scan.status.deleted',
    className: 'bg-gray-100 text-gray-800 border-gray-300',
  },
} as const

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const { t } = useTranslation()
  const config = statusConfig[status] || {
    labelKey: 'scan.status.onbekend',
    className: 'bg-gray-100 text-gray-800 border-gray-300',
  }

  const statusText = t(config.labelKey)

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        config.className,
        className
      )}
      role="status"
      aria-label={`Status: ${statusText}`}
    >
      {statusText}
    </span>
  )
}
